import { i18next } from '@ingenico/react-i18n';

import deDEAdvancedSearchLogicalDevice from '../../standalone-app/public/assets/locales/de-DE/advancedSearchLogicalDevice.json';
import deDEApk from '../../standalone-app/public/assets/locales/de-DE/apk.json';
import deDEApplication from '../../standalone-app/public/assets/locales/de-DE/application.json';
import deDEBulk from '../../standalone-app/public/assets/locales/de-DE/bulk.json';
import deDECallLogs from '../../standalone-app/public/assets/locales/de-DE/callLogs.json';
import deDECommon from '../../standalone-app/public/assets/locales/de-DE/common.json';
import deDEConfigurationProfile from '../../standalone-app/public/assets/locales/de-DE/configurationProfile.json';
import deDEDeployment from '../../standalone-app/public/assets/locales/de-DE/deployment.json';
import deDEDeployments from '../../standalone-app/public/assets/locales/de-DE/deployments.json';
import deDEDeviceApps from '../../standalone-app/public/assets/locales/de-DE/deviceApps.json';
import deDEDigitalReceipt from '../../standalone-app/public/assets/locales/de-DE/digitalReceipt.json';
import deDEDocuments from '../../standalone-app/public/assets/locales/de-DE/documents.json';
import deDEError from '../../standalone-app/public/assets/locales/de-DE/error.json';
import deDEErrorDiagnostics from '../../standalone-app/public/assets/locales/de-DE/errorDiagnostics.json';
import deDEEsign from '../../standalone-app/public/assets/locales/de-DE/esign.json';
import deDEEventLogs from '../../standalone-app/public/assets/locales/de-DE/eventLogs.json';
import deDEGroups from '../../standalone-app/public/assets/locales/de-DE/groups.json';
import deDEHms from '../../standalone-app/public/assets/locales/de-DE/hms.json';
import deDELogicalDevice from '../../standalone-app/public/assets/locales/de-DE/logicalDevice.json';
import deDEMerchant from '../../standalone-app/public/assets/locales/de-DE/merchant.json';
import deDEModules from '../../standalone-app/public/assets/locales/de-DE/modules.json';
import deDENotification from '../../standalone-app/public/assets/locales/de-DE/notification.json';
import deDEOrganization from '../../standalone-app/public/assets/locales/de-DE/organization.json';
import deDEPhysicalDevice from '../../standalone-app/public/assets/locales/de-DE/physicalDevice.json';
import deDEReports from '../../standalone-app/public/assets/locales/de-DE/reports.json';
import deDEResources from '../../standalone-app/public/assets/locales/de-DE/resources.json';
import deDEService from '../../standalone-app/public/assets/locales/de-DE/service.json';
import deDEServiceConfiguration from '../../standalone-app/public/assets/locales/de-DE/serviceConfiguration.json';
import deDESmartFields from '../../standalone-app/public/assets/locales/de-DE/smartFields.json';
import deDEStore from '../../standalone-app/public/assets/locales/de-DE/store.json';
import deDESubscription from '../../standalone-app/public/assets/locales/de-DE/subscription.json';
import deDESupports from '../../standalone-app/public/assets/locales/de-DE/supports.json';
import deDETags from '../../standalone-app/public/assets/locales/de-DE/tags.json';
import deDETasks from '../../standalone-app/public/assets/locales/de-DE/tasks.json';
import deDETransactions from '../../standalone-app/public/assets/locales/de-DE/transactions.json';
import deDEUser from '../../standalone-app/public/assets/locales/de-DE/user.json';
import enUSAdvancedSearchLogicalDevice from '../../standalone-app/public/assets/locales/en-US/advancedSearchLogicalDevice.json';
import enUSApk from '../../standalone-app/public/assets/locales/en-US/apk.json';
import enUSApplication from '../../standalone-app/public/assets/locales/en-US/application.json';
import enUSBulk from '../../standalone-app/public/assets/locales/en-US/bulk.json';
import enUSCallLogs from '../../standalone-app/public/assets/locales/en-US/callLogs.json';
import enUSCommon from '../../standalone-app/public/assets/locales/en-US/common.json';
import enUSConfigurationProfile from '../../standalone-app/public/assets/locales/en-US/configurationProfile.json';
import enUSDeployment from '../../standalone-app/public/assets/locales/en-US/deployment.json';
import enUSDeployments from '../../standalone-app/public/assets/locales/en-US/deployments.json';
import enUSDeviceApps from '../../standalone-app/public/assets/locales/en-US/deviceApps.json';
import enUSDigitalReceipt from '../../standalone-app/public/assets/locales/en-US/digitalReceipt.json';
import enUSDocuments from '../../standalone-app/public/assets/locales/en-US/documents.json';
import enUSError from '../../standalone-app/public/assets/locales/en-US/error.json';
import enUSErrorDiagnostics from '../../standalone-app/public/assets/locales/en-US/errorDiagnostics.json';
import enUSEsign from '../../standalone-app/public/assets/locales/en-US/esign.json';
import enUSEventLogs from '../../standalone-app/public/assets/locales/en-US/eventLogs.json';
import enUSGroups from '../../standalone-app/public/assets/locales/en-US/groups.json';
import enUSHms from '../../standalone-app/public/assets/locales/en-US/hms.json';
import enUSLogicalDevice from '../../standalone-app/public/assets/locales/en-US/logicalDevice.json';
import enUSMerchant from '../../standalone-app/public/assets/locales/en-US/merchant.json';
import enUSModules from '../../standalone-app/public/assets/locales/en-US/modules.json';
import enUSNotification from '../../standalone-app/public/assets/locales/en-US/notification.json';
import enUSOrganization from '../../standalone-app/public/assets/locales/en-US/organization.json';
import enUSPhysicalDevice from '../../standalone-app/public/assets/locales/en-US/physicalDevice.json';
import enUSReports from '../../standalone-app/public/assets/locales/en-US/reports.json';
import enUSResources from '../../standalone-app/public/assets/locales/en-US/resources.json';
import enUSService from '../../standalone-app/public/assets/locales/en-US/service.json';
import enUSServiceConfiguration from '../../standalone-app/public/assets/locales/en-US/serviceConfiguration.json';
import enUSSmartFields from '../../standalone-app/public/assets/locales/en-US/smartFields.json';
import enUSStore from '../../standalone-app/public/assets/locales/en-US/store.json';
import enUSSubscription from '../../standalone-app/public/assets/locales/en-US/subscription.json';
import enUSSupports from '../../standalone-app/public/assets/locales/en-US/supports.json';
import enUSTags from '../../standalone-app/public/assets/locales/en-US/tags.json';
import enUSTasks from '../../standalone-app/public/assets/locales/en-US/tasks.json';
import enUSTransactions from '../../standalone-app/public/assets/locales/en-US/transactions.json';
import enUSUser from '../../standalone-app/public/assets/locales/en-US/user.json';
import esESAdvancedSearchLogicalDevice from '../../standalone-app/public/assets/locales/es-ES/advancedSearchLogicalDevice.json';
import esESApk from '../../standalone-app/public/assets/locales/es-ES/apk.json';
import esESApplication from '../../standalone-app/public/assets/locales/es-ES/application.json';
import esESBulk from '../../standalone-app/public/assets/locales/es-ES/bulk.json';
import esESCallLogs from '../../standalone-app/public/assets/locales/es-ES/callLogs.json';
import esESCommon from '../../standalone-app/public/assets/locales/es-ES/common.json';
import esESConfigurationProfile from '../../standalone-app/public/assets/locales/es-ES/configurationProfile.json';
import esESDeployment from '../../standalone-app/public/assets/locales/es-ES/deployment.json';
import esESDeployments from '../../standalone-app/public/assets/locales/es-ES/deployments.json';
import esESDeviceApps from '../../standalone-app/public/assets/locales/es-ES/deviceApps.json';
import esESDigitalReceipt from '../../standalone-app/public/assets/locales/es-ES/digitalReceipt.json';
import esESDocuments from '../../standalone-app/public/assets/locales/es-ES/documents.json';
import esESError from '../../standalone-app/public/assets/locales/es-ES/error.json';
import esESErrorDiagnostics from '../../standalone-app/public/assets/locales/es-ES/errorDiagnostics.json';
import esESEsign from '../../standalone-app/public/assets/locales/es-ES/esign.json';
import esESEventLogs from '../../standalone-app/public/assets/locales/es-ES/eventLogs.json';
import esESGroups from '../../standalone-app/public/assets/locales/es-ES/groups.json';
import esESHms from '../../standalone-app/public/assets/locales/es-ES/hms.json';
import esESLogicalDevice from '../../standalone-app/public/assets/locales/es-ES/logicalDevice.json';
import esESMerchant from '../../standalone-app/public/assets/locales/es-ES/merchant.json';
import esESModules from '../../standalone-app/public/assets/locales/es-ES/modules.json';
import esESNotification from '../../standalone-app/public/assets/locales/es-ES/notification.json';
import esESOrganization from '../../standalone-app/public/assets/locales/es-ES/organization.json';
import esESPhysicalDevice from '../../standalone-app/public/assets/locales/es-ES/physicalDevice.json';
import esESReports from '../../standalone-app/public/assets/locales/es-ES/reports.json';
import esESResources from '../../standalone-app/public/assets/locales/es-ES/resources.json';
import esESService from '../../standalone-app/public/assets/locales/es-ES/service.json';
import esESServiceConfiguration from '../../standalone-app/public/assets/locales/es-ES/serviceConfiguration.json';
import esESSmartFields from '../../standalone-app/public/assets/locales/es-ES/smartFields.json';
import esESStore from '../../standalone-app/public/assets/locales/es-ES/store.json';
import esESSubscription from '../../standalone-app/public/assets/locales/es-ES/subscription.json';
import esESSupports from '../../standalone-app/public/assets/locales/es-ES/supports.json';
import esESTags from '../../standalone-app/public/assets/locales/es-ES/tags.json';
import esESTasks from '../../standalone-app/public/assets/locales/es-ES/tasks.json';
import esESTransactions from '../../standalone-app/public/assets/locales/es-ES/transactions.json';
import esESUser from '../../standalone-app/public/assets/locales/es-ES/user.json';
import esMXAdvancedSearchLogicalDevice from '../../standalone-app/public/assets/locales/es-MX/advancedSearchLogicalDevice.json';
import esMXApk from '../../standalone-app/public/assets/locales/es-MX/apk.json';
import esMXApplication from '../../standalone-app/public/assets/locales/es-MX/application.json';
import esMXBulk from '../../standalone-app/public/assets/locales/es-MX/bulk.json';
import esMXCallLogs from '../../standalone-app/public/assets/locales/es-MX/callLogs.json';
import esMXCommon from '../../standalone-app/public/assets/locales/es-MX/common.json';
import esMXConfigurationProfile from '../../standalone-app/public/assets/locales/es-MX/configurationProfile.json';
import esMXDeployment from '../../standalone-app/public/assets/locales/es-MX/deployment.json';
import esMXDeployments from '../../standalone-app/public/assets/locales/es-MX/deployments.json';
import esMXDeviceApps from '../../standalone-app/public/assets/locales/es-MX/deviceApps.json';
import esMXDigitalReceipt from '../../standalone-app/public/assets/locales/es-MX/digitalReceipt.json';
import esMXDocuments from '../../standalone-app/public/assets/locales/es-MX/documents.json';
import esMXError from '../../standalone-app/public/assets/locales/es-MX/error.json';
import esMXErrorDiagnostics from '../../standalone-app/public/assets/locales/es-MX/errorDiagnostics.json';
import esMXEsign from '../../standalone-app/public/assets/locales/es-MX/esign.json';
import esMXEventLogs from '../../standalone-app/public/assets/locales/es-MX/eventLogs.json';
import esMXGroups from '../../standalone-app/public/assets/locales/es-MX/groups.json';
import esMXHms from '../../standalone-app/public/assets/locales/es-MX/hms.json';
import esMXLogicalDevice from '../../standalone-app/public/assets/locales/es-MX/logicalDevice.json';
import esMXMerchant from '../../standalone-app/public/assets/locales/es-MX/merchant.json';
import esMXModules from '../../standalone-app/public/assets/locales/es-MX/modules.json';
import esMXNotification from '../../standalone-app/public/assets/locales/es-MX/notification.json';
import esMXOrganization from '../../standalone-app/public/assets/locales/es-MX/organization.json';
import esMXPhysicalDevice from '../../standalone-app/public/assets/locales/es-MX/physicalDevice.json';
import esMXReports from '../../standalone-app/public/assets/locales/es-MX/reports.json';
import esMXResources from '../../standalone-app/public/assets/locales/es-MX/resources.json';
import esMXService from '../../standalone-app/public/assets/locales/es-MX/service.json';
import esMXServiceConfiguration from '../../standalone-app/public/assets/locales/es-MX/serviceConfiguration.json';
import esMXSmartFields from '../../standalone-app/public/assets/locales/es-MX/smartFields.json';
import esMXStore from '../../standalone-app/public/assets/locales/es-MX/store.json';
import esMXSubscription from '../../standalone-app/public/assets/locales/es-MX/subscription.json';
import esMXSupports from '../../standalone-app/public/assets/locales/es-MX/supports.json';
import esMXTags from '../../standalone-app/public/assets/locales/es-MX/tags.json';
import esMXTasks from '../../standalone-app/public/assets/locales/es-MX/tasks.json';
import esMXTransactions from '../../standalone-app/public/assets/locales/es-MX/transactions.json';
import esMXUser from '../../standalone-app/public/assets/locales/es-MX/user.json';
import frFRAdvancedSearchLogicalDevice from '../../standalone-app/public/assets/locales/fr-FR/advancedSearchLogicalDevice.json';
import frFRApk from '../../standalone-app/public/assets/locales/fr-FR/apk.json';
import frFRApplication from '../../standalone-app/public/assets/locales/fr-FR/application.json';
import frFRBulk from '../../standalone-app/public/assets/locales/fr-FR/bulk.json';
import frFRCallLogs from '../../standalone-app/public/assets/locales/fr-FR/callLogs.json';
import frFRCommon from '../../standalone-app/public/assets/locales/fr-FR/common.json';
import frFRConfigurationProfile from '../../standalone-app/public/assets/locales/fr-FR/configurationProfile.json';
import frFRDeployment from '../../standalone-app/public/assets/locales/fr-FR/deployment.json';
import frFRDeployments from '../../standalone-app/public/assets/locales/fr-FR/deployments.json';
import frFRDeviceApps from '../../standalone-app/public/assets/locales/fr-FR/deviceApps.json';
import frFRDigitalReceipt from '../../standalone-app/public/assets/locales/fr-FR/digitalReceipt.json';
import frFRDocuments from '../../standalone-app/public/assets/locales/fr-FR/documents.json';
import frFRError from '../../standalone-app/public/assets/locales/fr-FR/error.json';
import frFRErrorDiagnostics from '../../standalone-app/public/assets/locales/fr-FR/errorDiagnostics.json';
import frFREsign from '../../standalone-app/public/assets/locales/fr-FR/esign.json';
import frFREventLogs from '../../standalone-app/public/assets/locales/fr-FR/eventLogs.json';
import frFRGroups from '../../standalone-app/public/assets/locales/fr-FR/groups.json';
import frFRHms from '../../standalone-app/public/assets/locales/fr-FR/hms.json';
import frFRLogicalDevice from '../../standalone-app/public/assets/locales/fr-FR/logicalDevice.json';
import frFRMerchant from '../../standalone-app/public/assets/locales/fr-FR/merchant.json';
import frFRModules from '../../standalone-app/public/assets/locales/fr-FR/modules.json';
import frFRNotification from '../../standalone-app/public/assets/locales/fr-FR/notification.json';
import frFROrganization from '../../standalone-app/public/assets/locales/fr-FR/organization.json';
import frFRPhysicalDevice from '../../standalone-app/public/assets/locales/fr-FR/physicalDevice.json';
import frFRReports from '../../standalone-app/public/assets/locales/fr-FR/reports.json';
import frFRResources from '../../standalone-app/public/assets/locales/fr-FR/resources.json';
import frFRService from '../../standalone-app/public/assets/locales/fr-FR/service.json';
import frFRServiceConfiguration from '../../standalone-app/public/assets/locales/fr-FR/serviceConfiguration.json';
import frFRSmartFields from '../../standalone-app/public/assets/locales/fr-FR/smartFields.json';
import frFRStore from '../../standalone-app/public/assets/locales/fr-FR/store.json';
import frFRSubscription from '../../standalone-app/public/assets/locales/fr-FR/subscription.json';
import frFRSupports from '../../standalone-app/public/assets/locales/fr-FR/supports.json';
import frFRTags from '../../standalone-app/public/assets/locales/fr-FR/tags.json';
import frFRTasks from '../../standalone-app/public/assets/locales/fr-FR/tasks.json';
import frFRTransactions from '../../standalone-app/public/assets/locales/fr-FR/transactions.json';
import frFRUser from '../../standalone-app/public/assets/locales/fr-FR/user.json';
import itITAdvancedSearchLogicalDevice from '../../standalone-app/public/assets/locales/it-IT/advancedSearchLogicalDevice.json';
import itITApk from '../../standalone-app/public/assets/locales/it-IT/apk.json';
import itITApplication from '../../standalone-app/public/assets/locales/it-IT/application.json';
import itITBulk from '../../standalone-app/public/assets/locales/it-IT/bulk.json';
import itITCallLogs from '../../standalone-app/public/assets/locales/it-IT/callLogs.json';
import itITCommon from '../../standalone-app/public/assets/locales/it-IT/common.json';
import itITConfigurationProfile from '../../standalone-app/public/assets/locales/it-IT/configurationProfile.json';
import itITDeployment from '../../standalone-app/public/assets/locales/it-IT/deployment.json';
import itITDeployments from '../../standalone-app/public/assets/locales/it-IT/deployments.json';
import itITDeviceApps from '../../standalone-app/public/assets/locales/it-IT/deviceApps.json';
import itITDigitalReceipt from '../../standalone-app/public/assets/locales/it-IT/digitalReceipt.json';
import itITDocuments from '../../standalone-app/public/assets/locales/it-IT/documents.json';
import itITError from '../../standalone-app/public/assets/locales/it-IT/error.json';
import itITErrorDiagnostics from '../../standalone-app/public/assets/locales/it-IT/errorDiagnostics.json';
import itITEsign from '../../standalone-app/public/assets/locales/it-IT/esign.json';
import itITEventLogs from '../../standalone-app/public/assets/locales/it-IT/eventLogs.json';
import itITGroups from '../../standalone-app/public/assets/locales/it-IT/groups.json';
import itITHms from '../../standalone-app/public/assets/locales/it-IT/hms.json';
import itITLogicalDevice from '../../standalone-app/public/assets/locales/it-IT/logicalDevice.json';
import itITMerchant from '../../standalone-app/public/assets/locales/it-IT/merchant.json';
import itITModules from '../../standalone-app/public/assets/locales/it-IT/modules.json';
import itITNotification from '../../standalone-app/public/assets/locales/it-IT/notification.json';
import itITOrganization from '../../standalone-app/public/assets/locales/it-IT/organization.json';
import itITPhysicalDevice from '../../standalone-app/public/assets/locales/it-IT/physicalDevice.json';
import itITReports from '../../standalone-app/public/assets/locales/it-IT/reports.json';
import itITResources from '../../standalone-app/public/assets/locales/it-IT/resources.json';
import itITService from '../../standalone-app/public/assets/locales/it-IT/service.json';
import itITServiceConfiguration from '../../standalone-app/public/assets/locales/it-IT/serviceConfiguration.json';
import itITSmartFields from '../../standalone-app/public/assets/locales/it-IT/smartFields.json';
import itITStore from '../../standalone-app/public/assets/locales/it-IT/store.json';
import itITSubscription from '../../standalone-app/public/assets/locales/it-IT/subscription.json';
import itITSupports from '../../standalone-app/public/assets/locales/it-IT/supports.json';
import itITTags from '../../standalone-app/public/assets/locales/it-IT/tags.json';
import itITTasks from '../../standalone-app/public/assets/locales/it-IT/tasks.json';
import itITTransactions from '../../standalone-app/public/assets/locales/it-IT/transactions.json';
import itITUser from '../../standalone-app/public/assets/locales/it-IT/user.json';
import placeholderAdvancedSearchLogicalDevice from '../../standalone-app/public/assets/locales/placeholder/advancedSearchLogicalDevice.json';
import placeholderApk from '../../standalone-app/public/assets/locales/placeholder/apk.json';
import placeholderApplication from '../../standalone-app/public/assets/locales/placeholder/application.json';
import placeholderBulk from '../../standalone-app/public/assets/locales/placeholder/bulk.json';
import placeholderCallLogs from '../../standalone-app/public/assets/locales/placeholder/callLogs.json';
import placeholderCommon from '../../standalone-app/public/assets/locales/placeholder/common.json';
import placeholderConfigurationProfile from '../../standalone-app/public/assets/locales/placeholder/configurationProfile.json';
import placeholderDeployment from '../../standalone-app/public/assets/locales/placeholder/deployment.json';
import placeholderDeployments from '../../standalone-app/public/assets/locales/placeholder/deployments.json';
import placeholderDeviceApps from '../../standalone-app/public/assets/locales/placeholder/deviceApps.json';
import placeholderDigitalReceipt from '../../standalone-app/public/assets/locales/placeholder/digitalReceipt.json';
import placeholderDocuments from '../../standalone-app/public/assets/locales/placeholder/documents.json';
import placeholderError from '../../standalone-app/public/assets/locales/placeholder/error.json';
import placeholderErrorDiagnostics from '../../standalone-app/public/assets/locales/placeholder/errorDiagnostics.json';
import placeholderEsign from '../../standalone-app/public/assets/locales/placeholder/esign.json';
import placeholderEventLogs from '../../standalone-app/public/assets/locales/placeholder/eventLogs.json';
import placeholderGroups from '../../standalone-app/public/assets/locales/placeholder/groups.json';
import placeholderHms from '../../standalone-app/public/assets/locales/placeholder/hms.json';
import placeholderLogicalDevice from '../../standalone-app/public/assets/locales/placeholder/logicalDevice.json';
import placeholderMerchant from '../../standalone-app/public/assets/locales/placeholder/merchant.json';
import placeholderModules from '../../standalone-app/public/assets/locales/placeholder/modules.json';
import placeholderNotification from '../../standalone-app/public/assets/locales/placeholder/notification.json';
import placeholderOrganization from '../../standalone-app/public/assets/locales/placeholder/organization.json';
import placeholderPhysicalDevice from '../../standalone-app/public/assets/locales/placeholder/physicalDevice.json';
import placeholderReports from '../../standalone-app/public/assets/locales/placeholder/reports.json';
import placeholderResources from '../../standalone-app/public/assets/locales/placeholder/resources.json';
import placeholderService from '../../standalone-app/public/assets/locales/placeholder/service.json';
import placeholderServiceConfiguration from '../../standalone-app/public/assets/locales/placeholder/serviceConfiguration.json';
import placeholderSmartFields from '../../standalone-app/public/assets/locales/placeholder/smartFields.json';
import placeholderStore from '../../standalone-app/public/assets/locales/placeholder/store.json';
import placeholderSubscription from '../../standalone-app/public/assets/locales/placeholder/subscription.json';
import placeholderSupports from '../../standalone-app/public/assets/locales/placeholder/supports.json';
import placeholderTags from '../../standalone-app/public/assets/locales/placeholder/tags.json';
import placeholderTasks from '../../standalone-app/public/assets/locales/placeholder/tasks.json';
import placeholderTransactions from '../../standalone-app/public/assets/locales/placeholder/transactions.json';
import placeholderUser from '../../standalone-app/public/assets/locales/placeholder/user.json';

type TranslationBundle = Record<string, unknown>;

const DEVICE_MANAGEMENT_TRANSLATION_BUNDLES: Record<string, Record<string, TranslationBundle>> = {
  'de-DE': {
    advancedSearchLogicalDevice: deDEAdvancedSearchLogicalDevice,
    apk: deDEApk,
    application: deDEApplication,
    bulk: deDEBulk,
    callLogs: deDECallLogs,
    common: deDECommon,
    configurationProfile: deDEConfigurationProfile,
    deployment: deDEDeployment,
    deployments: deDEDeployments,
    deviceApps: deDEDeviceApps,
    digitalReceipt: deDEDigitalReceipt,
    documents: deDEDocuments,
    error: deDEError,
    errorDiagnostics: deDEErrorDiagnostics,
    esign: deDEEsign,
    eventLogs: deDEEventLogs,
    groups: deDEGroups,
    hms: deDEHms,
    logicalDevice: deDELogicalDevice,
    merchant: deDEMerchant,
    modules: deDEModules,
    notification: deDENotification,
    organization: deDEOrganization,
    physicalDevice: deDEPhysicalDevice,
    reports: deDEReports,
    resources: deDEResources,
    service: deDEService,
    serviceConfiguration: deDEServiceConfiguration,
    smartFields: deDESmartFields,
    store: deDEStore,
    subscription: deDESubscription,
    supports: deDESupports,
    tags: deDETags,
    tasks: deDETasks,
    transactions: deDETransactions,
    user: deDEUser,
  },
  'en-US': {
    advancedSearchLogicalDevice: enUSAdvancedSearchLogicalDevice,
    apk: enUSApk,
    application: enUSApplication,
    bulk: enUSBulk,
    callLogs: enUSCallLogs,
    common: enUSCommon,
    configurationProfile: enUSConfigurationProfile,
    deployment: enUSDeployment,
    deployments: enUSDeployments,
    deviceApps: enUSDeviceApps,
    digitalReceipt: enUSDigitalReceipt,
    documents: enUSDocuments,
    error: enUSError,
    errorDiagnostics: enUSErrorDiagnostics,
    esign: enUSEsign,
    eventLogs: enUSEventLogs,
    groups: enUSGroups,
    hms: enUSHms,
    logicalDevice: enUSLogicalDevice,
    merchant: enUSMerchant,
    modules: enUSModules,
    notification: enUSNotification,
    organization: enUSOrganization,
    physicalDevice: enUSPhysicalDevice,
    reports: enUSReports,
    resources: enUSResources,
    service: enUSService,
    serviceConfiguration: enUSServiceConfiguration,
    smartFields: enUSSmartFields,
    store: enUSStore,
    subscription: enUSSubscription,
    supports: enUSSupports,
    tags: enUSTags,
    tasks: enUSTasks,
    transactions: enUSTransactions,
    user: enUSUser,
  },
  'es-ES': {
    advancedSearchLogicalDevice: esESAdvancedSearchLogicalDevice,
    apk: esESApk,
    application: esESApplication,
    bulk: esESBulk,
    callLogs: esESCallLogs,
    common: esESCommon,
    configurationProfile: esESConfigurationProfile,
    deployment: esESDeployment,
    deployments: esESDeployments,
    deviceApps: esESDeviceApps,
    digitalReceipt: esESDigitalReceipt,
    documents: esESDocuments,
    error: esESError,
    errorDiagnostics: esESErrorDiagnostics,
    esign: esESEsign,
    eventLogs: esESEventLogs,
    groups: esESGroups,
    hms: esESHms,
    logicalDevice: esESLogicalDevice,
    merchant: esESMerchant,
    modules: esESModules,
    notification: esESNotification,
    organization: esESOrganization,
    physicalDevice: esESPhysicalDevice,
    reports: esESReports,
    resources: esESResources,
    service: esESService,
    serviceConfiguration: esESServiceConfiguration,
    smartFields: esESSmartFields,
    store: esESStore,
    subscription: esESSubscription,
    supports: esESSupports,
    tags: esESTags,
    tasks: esESTasks,
    transactions: esESTransactions,
    user: esESUser,
  },
  'es-MX': {
    advancedSearchLogicalDevice: esMXAdvancedSearchLogicalDevice,
    apk: esMXApk,
    application: esMXApplication,
    bulk: esMXBulk,
    callLogs: esMXCallLogs,
    common: esMXCommon,
    configurationProfile: esMXConfigurationProfile,
    deployment: esMXDeployment,
    deployments: esMXDeployments,
    deviceApps: esMXDeviceApps,
    digitalReceipt: esMXDigitalReceipt,
    documents: esMXDocuments,
    error: esMXError,
    errorDiagnostics: esMXErrorDiagnostics,
    esign: esMXEsign,
    eventLogs: esMXEventLogs,
    groups: esMXGroups,
    hms: esMXHms,
    logicalDevice: esMXLogicalDevice,
    merchant: esMXMerchant,
    modules: esMXModules,
    notification: esMXNotification,
    organization: esMXOrganization,
    physicalDevice: esMXPhysicalDevice,
    reports: esMXReports,
    resources: esMXResources,
    service: esMXService,
    serviceConfiguration: esMXServiceConfiguration,
    smartFields: esMXSmartFields,
    store: esMXStore,
    subscription: esMXSubscription,
    supports: esMXSupports,
    tags: esMXTags,
    tasks: esMXTasks,
    transactions: esMXTransactions,
    user: esMXUser,
  },
  'fr-FR': {
    advancedSearchLogicalDevice: frFRAdvancedSearchLogicalDevice,
    apk: frFRApk,
    application: frFRApplication,
    bulk: frFRBulk,
    callLogs: frFRCallLogs,
    common: frFRCommon,
    configurationProfile: frFRConfigurationProfile,
    deployment: frFRDeployment,
    deployments: frFRDeployments,
    deviceApps: frFRDeviceApps,
    digitalReceipt: frFRDigitalReceipt,
    documents: frFRDocuments,
    error: frFRError,
    errorDiagnostics: frFRErrorDiagnostics,
    esign: frFREsign,
    eventLogs: frFREventLogs,
    groups: frFRGroups,
    hms: frFRHms,
    logicalDevice: frFRLogicalDevice,
    merchant: frFRMerchant,
    modules: frFRModules,
    notification: frFRNotification,
    organization: frFROrganization,
    physicalDevice: frFRPhysicalDevice,
    reports: frFRReports,
    resources: frFRResources,
    service: frFRService,
    serviceConfiguration: frFRServiceConfiguration,
    smartFields: frFRSmartFields,
    store: frFRStore,
    subscription: frFRSubscription,
    supports: frFRSupports,
    tags: frFRTags,
    tasks: frFRTasks,
    transactions: frFRTransactions,
    user: frFRUser,
  },
  'it-IT': {
    advancedSearchLogicalDevice: itITAdvancedSearchLogicalDevice,
    apk: itITApk,
    application: itITApplication,
    bulk: itITBulk,
    callLogs: itITCallLogs,
    common: itITCommon,
    configurationProfile: itITConfigurationProfile,
    deployment: itITDeployment,
    deployments: itITDeployments,
    deviceApps: itITDeviceApps,
    digitalReceipt: itITDigitalReceipt,
    documents: itITDocuments,
    error: itITError,
    errorDiagnostics: itITErrorDiagnostics,
    esign: itITEsign,
    eventLogs: itITEventLogs,
    groups: itITGroups,
    hms: itITHms,
    logicalDevice: itITLogicalDevice,
    merchant: itITMerchant,
    modules: itITModules,
    notification: itITNotification,
    organization: itITOrganization,
    physicalDevice: itITPhysicalDevice,
    reports: itITReports,
    resources: itITResources,
    service: itITService,
    serviceConfiguration: itITServiceConfiguration,
    smartFields: itITSmartFields,
    store: itITStore,
    subscription: itITSubscription,
    supports: itITSupports,
    tags: itITTags,
    tasks: itITTasks,
    transactions: itITTransactions,
    user: itITUser,
  },
  placeholder: {
    advancedSearchLogicalDevice: placeholderAdvancedSearchLogicalDevice,
    apk: placeholderApk,
    application: placeholderApplication,
    bulk: placeholderBulk,
    callLogs: placeholderCallLogs,
    common: placeholderCommon,
    configurationProfile: placeholderConfigurationProfile,
    deployment: placeholderDeployment,
    deployments: placeholderDeployments,
    deviceApps: placeholderDeviceApps,
    digitalReceipt: placeholderDigitalReceipt,
    documents: placeholderDocuments,
    error: placeholderError,
    errorDiagnostics: placeholderErrorDiagnostics,
    esign: placeholderEsign,
    eventLogs: placeholderEventLogs,
    groups: placeholderGroups,
    hms: placeholderHms,
    logicalDevice: placeholderLogicalDevice,
    merchant: placeholderMerchant,
    modules: placeholderModules,
    notification: placeholderNotification,
    organization: placeholderOrganization,
    physicalDevice: placeholderPhysicalDevice,
    reports: placeholderReports,
    resources: placeholderResources,
    service: placeholderService,
    serviceConfiguration: placeholderServiceConfiguration,
    smartFields: placeholderSmartFields,
    store: placeholderStore,
    subscription: placeholderSubscription,
    supports: placeholderSupports,
    tags: placeholderTags,
    tasks: placeholderTasks,
    transactions: placeholderTransactions,
    user: placeholderUser,
  },
};

export function registerDeviceManagementTranslations(): void {
  for (const [language, namespaces] of Object.entries(DEVICE_MANAGEMENT_TRANSLATION_BUNDLES)) {
    for (const [namespace, resources] of Object.entries(namespaces)) {
      i18next.addResourceBundle(language, namespace, resources, true, false);
    }
  }
}
